function isProductionHost() {
  return window.location.host.startsWith('app')
}

export { isProductionHost }
